var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"invite-chip",attrs:{"outlined":"","color":"secondary"}},[_c('v-icon',{attrs:{"color":"secondary","left":""}},[_vm._v("mdi-email-newsletter")]),_vm._v("招待中 ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }